define('models/UniversalLinkCollection',['ObjectCollection','LocalStorage','models/UniversalLinkModel'],function (ObjectCollection,LocalStorage,UniversalLinkModel) {
    //
    // Collection UniversalLink
    //
    var UniversalLinkCollectionPrototype = {
        
        name:'UniversalLinkCollection',
        route:'apiUniversalLinkCollection',
        model:UniversalLinkModel,

        getDeeplink:function(url){
            var deeplink = false;
            this.each(function(universalLink){
               if(!deeplink){
                   var toDeeplink = universalLink.toDeeplink(url);
                    if(toDeeplink){
                        deeplink = toDeeplink;
                    }
               }
            });
            return deeplink;
        }
    };

    var UniversalLinkCollection = ObjectCollection.extend(LocalStorage).extend(UniversalLinkCollectionPrototype);

    return UniversalLinkCollection;
});
